import { useEffect, useRef, useState } from "react";

interface HoverTooltipProps {
  text: string;
}

const HoverTooltip = ({ text }: HoverTooltipProps) => {
  const [ currentPosition, setCurrentPosition ] = useState<{ left: number; top: number }>({ left: 0, top: 0 });
  const tooltipRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setCurrentPosition({ left: e.clientX, top: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const left = currentPosition.left - (tooltipRef.current?.offsetWidth || 0) / 2;

  const tooltipStyle: React.CSSProperties = {
    top: `${currentPosition.top - 40}px`,
    left: `${Math.max(0, Math.min(left, window.innerWidth - (tooltipRef.current?.offsetWidth || 0)))}px`,
  };

  return (
    <span
      ref={tooltipRef}
      className="absolute -left-1/2 z-[1000] pointer-events-none opacity-100 transition bg-black text-white text-xs rounded py-1 px-2 whitespace-nowrap"
      style={tooltipStyle}
    >
      {text}
    </span>
  );
};

export default HoverTooltip;